import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	FormGroup,
	Label,
	Row,
	Col,
	Input,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import {
	getMiniVendors,
	getMini2Vendors,
	setSub2LocationParams,
	getMini2SubLocations,
	clearMini2SubLocations,
	getUserLocations,
} from "../../../store/Mini/actions";

import { getSRFQFilterList } from "../../../store/Quotation/actions";
import { ResetSubLocation } from "../../../store/CompareQuotation/actions";
import {
	getWOreportslist,
	WOreportslistSuccessful,
	reportTypeCheck,
	SetParams,
	ReportsChangeValue,
	ReportsSelecteChangeValue,
} from "../../../store/Reports/actions";

// const mrStatus = [
//   { value: "0", label: "All" },
//   { value: "1,2", label: "Pedning" },
//   { value: "3", label: "HOD(U) Approved" },
//   { value: "4", label: "HOD(U) Rejected" },
//   { value: "5", label: "HOD(M) Approved" },
//   { value: "6", label: "HOD(M) Rejected" },

// ];
var date = new Date(),
	y = date.getFullYear(),
	m = date.getMonth();
class SRPOReports extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.ReportsChangeHandeler = this.ReportsChangeHandeler.bind(this);
	}

	componentDidMount() {
		this.props.getMiniVendors();
		this.props.getMini2Vendors();
		this.props.getSRFQFilterList();
		this.props.getUserLocations();
		this.props.SetParams({});
	}
	ReportsChangeHandeler(e) {
		this.props.ReportsChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
		if (this.props.reportType === "document") {
			this.props.getWOreportslist({
				...this.props.params,
				[e.target.name]: e.target.value,
			});
		}
	}
	SelecteChangeValue({ key, label, key2, value }) {
		this.props.ReportsSelecteChangeValue({
			key,
			label,
			key2,
			value,
		});
		if (this.props.reportType === "document") {
			this.props.getWOreportslist({
				...this.props.params,
				[key2]: value,
			});
		}
	}
	reportType(e) {
		this.props.reportTypeCheck({ value: e.target.value });

		this.props.WOreportslistSuccessful([]);
		if (e.target.value === "document") {
			this.props.getWOreportslist({
				...this.props.params,
				start_date:
					this.props.params.start_date == null ||
					this.props.params.start_date === ""
						? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
						: this.props.params.start_date,
				end_date:
					this.props.params.end_date == null ||
					this.props.params.end_date === ""
						? moment(new Date()).format("YYYY-MM-DD")
						: this.props.params.end_date,
			});
		}
	}
	componentDidUpdate(prevProps) {
		if (
			prevProps.Reportdata.location !== this.props.Reportdata.location ||
			prevProps.Reportdata.cost_center_type !==
				this.props.Reportdata.cost_center_type
		) {
			this.GetMIniSubLocations(this.props);
			this.props.ResetSubLocation();
		}
	}

	GetMIniSubLocations(props) {
		const { Reportdata, getMini2SubLocations, sublocationParamas2 } = props;

		if (Reportdata.location !== undefined) {
			getMini2SubLocations({
				location: Reportdata.location,
				cost_center_type: Reportdata.cost_center_type,
				page: 1,
				page_size: 10,
			});
		}
	}

	reportCheck(e) {
		this.props.ReportsChangeValue({
			key: "action",
			value: e.target.value,
		});
	}
	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom ">
										<Link
											to="/reports"
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										<h5 className="card-title-18 pt-2 d-inline-block">
											Work Order Report
										</h5>
									</CardHeader>
									<CardBody className="pt-1">
										<Row className="p-1">
											<Col md={12}>
												<Card className="p-1">
													<CardBody className="pt-1">
														<Row>
															<Col
																md={3}
																className="mb-0">
																<FormGroup className="mb-0 pb-0">
																	<Label
																		htmlFor="validationFromDate"
																		className="col-form-label">
																		From
																		Date:
																	</Label>

																	<Input
																		className="mb-0 form-control "
																		type="date"
																		value={
																			this
																				.props
																				.params
																				.start_date ==
																				null ||
																			this
																				.props
																				.params
																				.start_date ===
																				""
																				? moment(
																						new Date(
																							y,
																							m,
																							1
																						)
																				  ).format(
																						"YYYY-MM-DD"
																				  )
																				: this
																						.props
																						.params
																						.start_date
																		}
																		onChange={(
																			e
																		) => {
																			this.ReportsChangeHandeler(
																				e
																			);
																		}}
																		id="CProduct-Name-text-input"
																		name="start_date"
																		placeholder="select Date"
																		max={moment(
																			new Date()
																		).format(
																			"YYYY-MM-DD"
																		)}
																	/>
																</FormGroup>
															</Col>
															<Col
																md={3}
																className="mb-0">
																<FormGroup className="mb-0 pb-0">
																	<Label
																		htmlFor="validationToDate"
																		className="mb-0 col-form-label">
																		To Date:
																	</Label>

																	<Input
																		className="mb-0 form-control "
																		type="date"
																		value={
																			this
																				.props
																				.params
																				.end_date ==
																				null ||
																			this
																				.props
																				.params
																				.end_date ===
																				""
																				? moment(
																						new Date()
																				  ).format(
																						"YYYY-MM-DD"
																				  )
																				: this
																						.props
																						.params
																						.end_date
																		}
																		onChange={(
																			e
																		) => {
																			this.ReportsChangeHandeler(
																				e
																			);
																		}}
																		id="CProduct-Name-text-input"
																		name="end_date"
																		placeholder="select Date"
																		disabled={
																			this
																				.props
																				.params
																				.start_date ===
																			""
																				? true
																				: false
																		}
																		min={
																			this
																				.props
																				.params
																				.start_date ==
																				null ||
																			this
																				.props
																				.params
																				.start_date ===
																				""
																				? moment(
																						new Date(
																							y,
																							m,
																							1
																						)
																				  ).format(
																						"YYYY-MM-DD"
																				  )
																				: moment(
																						this
																							.props
																							.params
																							.start_date
																				  ).format(
																						"YYYY-MM-DD"
																				  )
																		}
																		max={moment(
																			new Date()
																		).format(
																			"YYYY-MM-DD"
																		)}
																	/>
																</FormGroup>
															</Col>
															<Col md={3}>
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="Location-selection"
																		className="col-form-label">
																		Service
																		Request
																		For
																		Quotation
																		:
																	</Label>

																	<Select
																		id="Department-selection"
																		name="Department-selection"
																		classNamePrefix="select2-selection"
																		menuPortalTarget={
																			document.body
																		}
																		styles={{
																			menuPortal:
																				(
																					base
																				) => ({
																					...base,
																					zIndex: 9999,
																				}),
																		}}
																		options={this.props.srfqFilterList.map(
																			(
																				item,
																				index
																			) => ({
																				label: item.code,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this
																				.props
																				.Reportdata
																				?.requestforquotationlabel,
																			value: this
																				.props
																				.params
																				?.servicerequestforquotation,
																		}}
																		onChange={(
																			e
																		) => {
																			this.SelecteChangeValue(
																				{
																					key: "requestforquotationlabel",
																					label: e.label,
																					key2: "servicerequestforquotation",
																					value: e.value,
																				}
																			);
																		}}
																	/>
																</FormGroup>
															</Col>
															<Col md={3}>
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="vendorslist-selection"
																		className="col-form-label">
																		Vendors
																		List :
																	</Label>

																	<Select
																		id="vendorslist-selection"
																		name="vendorslist-selection"
																		classNamePrefix="select2-selection"
																		menuPortalTarget={
																			document.body
																		}
																		styles={{
																			menuPortal:
																				(
																					base
																				) => ({
																					...base,
																					zIndex: 9999,
																				}),
																		}}
																		options={this.props.vendorslist2.map(
																			(
																				item,
																				index
																			) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this
																				.props
																				.Reportdata
																				?.vendorlabel,
																			value: this
																				.props
																				.params
																				?.vendor,
																		}}
																		onChange={(
																			e
																		) => {
																			this.SelecteChangeValue(
																				{
																					key: "vendorlabel",
																					label: e.label,
																					key2: "vendor",
																					value: e.value,
																				}
																			);
																		}}
																		loading={
																			this
																				.props
																				.vendorsLoading
																		}
																		onInputChange={(
																			inputValue,
																			{
																				action,
																			}
																		) => {
																			// Only trigger search on user input, not on select/deselect
																			if (
																				action ===
																				"input-change"
																			) {
																				this.props.getMiniVendors(
																					{
																						...this
																							.props
																							.vendorParams,
																						page: 1,
																						page_size: 10,
																						search: inputValue,
																					}
																				);
																			}
																		}}
																		onMenuOpen={() => {
																			this.props.getMiniVendors(
																				{
																					...this
																						.props
																						.vendorParams,
																					page: 1,
																					page_size: 10,
																					search: "",
																				}
																			);
																		}}
																		// onMenuClose={() => {
																		// 	this.props.clearMiniVendors();
																		// }}
																		onMenuScrollToBottom={() => {
																			if (
																				this
																					.props
																					.vendorParams
																					.page <
																				this
																					.props
																					.vendorParams
																					.no_of_pages
																			) {
																				this.props.getMiniVendors(
																					{
																						...this
																							.props
																							.vendorParams,
																						page:
																							this
																								.props
																								.vendorParams
																								.page +
																							1,
																						page_size: 10,
																					}
																				);
																			}
																		}}
																	/>
																</FormGroup>
															</Col>

															{/* <Col md={3}>
                                <FormGroup>
                                  <Label
                                    htmlFor="transport_by"
                                    className="col-form-label "
                                  >
                                    Transport Type :
                                  </Label>
                                  <Select
                                    id="transport_by"
                                    name="transport_by"
                                    classNamePrefix="select2-selection"
                                    options={[
                                      {
                                        label: "Buyer",
                                        value: 1,
                                      },
                                      {
                                        label: "Seller",
                                        value: 2,
                                      },
                                    ].map((item) => ({
                                      label: item.label,
                                      value: item.value,
                                    }))}
                                    value={{
                                      label:
                                        this.props.Reportdata
                                          ?.transport_by_label == null
                                          ? "Select Transport Type"
                                          : this.props.Reportdata
                                              ?.transport_by_label,
                                      value:
                                        this.props.Reportdata
                                          ?.transport_by,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "transport_by_label",
                                        label: e.label,
                                        key2: "transport_by",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col> */}

															<Col md={3}>
																<FormGroup>
																	<Label
																		htmlFor="PnF"
																		className="col-form-label ">
																		Location
																		:
																	</Label>
																	<Select
																		id="location_id_select"
																		name="location_id_select"
																		classNamePrefix="select2-selection"
																		options={this.props.userLocation.map(
																			(
																				item
																			) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label:
																				this
																					.props
																					.Reportdata
																					?.userLocationLabel ==
																				null
																					? "Select Location"
																					: this
																							.props
																							.Reportdata
																							?.userLocationLabel,
																			value: this
																				.props
																				.Reportdata
																				?.location,
																		}}
																		onChange={(
																			e
																		) => {
																			this.SelecteChangeValue(
																				{
																					key: "userLocationLabel",
																					label: e.label,
																					key2: "location",
																					value: e.value,
																				}
																			);
																		}}
																	/>
																</FormGroup>
															</Col>

															{/* <Col md={3}>
                                <FormGroup>
                                  <Label
                                    htmlFor="costCenter"
                                    className="col-form-label "
                                  >
                                    Cost Center Type :
                                  </Label>
                                  <Select
                                    id="costCenter"
                                    name="costCenter"
                                    classNamePrefix="select2-selection"
                                    options={[
                                      {
                                        label: "Company",
                                        value: 1,
                                        key: "1",
                                      },
                                      {
                                        label: "personal",
                                        value: 2,
                                        key: "2",
                                      },
                                    ].map((item) => ({
                                      label: item.label,
                                      value: item.value,
                                    }))}
                                    value={{
                                      label:
                                        this.props.Reportdata?.costCenterType ==
                                        null
                                          ? "Select Cost Center Type"
                                          : this.props.Reportdata
                                              ?.costCenterType,
                                      value:
                                        this.props.Reportdata
                                          ?.cost_center_type,
                                    }}
                                    onChange={(e) => {
                                      this.SelecteChangeValue({
                                        key: "costCenterType",
                                        label: e.label,
                                        key2: "cost_center_type",
                                        value: e.value,
                                      });
                                    }}
                                  />
                                </FormGroup>
                              </Col> */}

															{this.props
																.Reportdata
																.costCenterType &&
															this.props
																.Reportdata
																.userLocationLabel !==
																undefined ? (
																<Col md={3}>
																	<FormGroup>
																		<Label
																			htmlFor="sublocation"
																			className="col-form-label ">
																			Sub
																			Location
																			:
																		</Label>
																		<Select
																			id="sublocation"
																			name="sublocation"
																			classNamePrefix="select2-selection"
																			onInputChange={(
																				value,
																				{
																					action,
																				}
																			) => {
																				if (
																					action ===
																					"input-change"
																				) {
																					this.props.setSub2LocationParams(
																						{
																							...this
																								.props
																								.sublocationParamas2,
																							page: 1,
																							page_size: 10,
																							search: value,
																						}
																					);
																					this.props.getMini2SubLocations(
																						{
																							location:
																								this
																									.props
																									.params
																									.location,
																							cost_center_type:
																								this
																									.props
																									.params
																									.cost_center_type,
																							page: 1,
																							page_size: 10,
																							search: value,
																						}
																					);
																				}
																			}}
																			options={this.props?.sublocationslist2?.results?.map(
																				(
																					item
																				) => ({
																					label: item.name,
																					value: item.id,
																				})
																			)}
																			onMenuOpen={() => {
																				this.props.clearMini2SubLocations(
																					{}
																				);
																				this.props.setSub2LocationParams(
																					{
																						...this
																							.props
																							.sublocationParamas2,
																						page: 1,
																						page_size: 10,
																					}
																				);
																				this.props.getMini2SubLocations(
																					{
																						location:
																							this
																								.props
																								.params
																								.location,
																						cost_center_type:
																							this
																								.props
																								.params
																								.cost_center_type,
																						page: 1,
																						page_size: 10,
																					}
																				);
																			}}
																			onMenuScrollToBottom={() => {
																				if (
																					this
																						.props
																						.sublocationParamas2
																						.page <
																					this
																						.props
																						.sublocationParamas2
																						.no_of_pages
																				) {
																					this.props.setSub2LocationParams(
																						{
																							...this
																								.props
																								.sublocationParamas2,
																							page:
																								this
																									.props
																									.sublocationParamas2
																									.page +
																								1,
																							page_size: 10,
																						}
																					);
																					this.props.getMini2SubLocations(
																						{
																							location:
																								this
																									.props
																									.params
																									.location,
																							cost_center_type:
																								this
																									.props
																									.params
																									.cost_center_type,
																							page:
																								this
																									.props
																									.sublocationParamas2
																									.page +
																								1,
																							page_size: 10,
																						}
																					);
																				}
																			}}
																			value={{
																				label:
																					this
																						.props
																						.Reportdata
																						?.subLocationLabel ==
																					null
																						? "Select Cost Center Type"
																						: this
																								.props
																								.Reportdata
																								?.subLocationLabel,
																				value: this
																					.props
																					.Reportdata
																					?.sublocation,
																			}}
																			onChange={(
																				e
																			) => {
																				this.SelecteChangeValue(
																					{
																						key: "subLocationLabel",
																						label: e.label,
																						key2: "sublocation",
																						value: e.value,
																					}
																				);
																			}}
																		/>
																	</FormGroup>
																</Col>
															) : (
																<Col
																	md={
																		3
																	}></Col>
															)}

															<Col
																md={6}
																className="mt-1 text-center font-size-14">
																<div className="mb-1">
																	<Label>
																		&nbsp;
																	</Label>
																</div>
																<div className="border p-2">
																	<div className="radio d-inline-block mr-5">
																		<Input
																			type="radio"
																			value="list"
																			name="reportType"
																			checked={
																				// true
																				this
																					.props
																					.reportType ===
																				"list"
																					? true
																					: false
																			}
																			onClick={(
																				e
																			) =>
																				this.reportType(
																					e
																				)
																			}
																		/>
																		PO List
																	</div>
																	<div className="radio d-inline-block mr-5">
																		<Input
																			type="radio"
																			value="PendingList"
																			name="reportType"
																			checked={
																				// true
																				this
																					.props
																					.reportType ===
																				"PendingList"
																					? true
																					: false
																			}
																			onClick={(
																				e
																			) =>
																				this.reportType(
																					e
																				)
																			}
																		/>
																		Pending
																		report
																	</div>
																	<div className="radio d-inline-block">
																		<Input
																			type="radio"
																			value="document"
																			name="reportType"
																			checked={
																				this
																					.props
																					.reportType ===
																				"document"
																					? true
																					: false
																			}
																			onClick={(
																				e
																			) =>
																				this.reportType(
																					e
																				)
																			}
																		/>
																		Document
																	</div>
																</div>
															</Col>
															{this.props
																.reportType ===
																"document" && (
																<Col md={3}>
																	<FormGroup className="mb-0">
																		<Label
																			htmlFor="MR_Code-selection"
																			className="col-form-label">
																			PO
																			Code
																			:
																		</Label>

																		<Select
																			id="MR_Code-selection"
																			name="MR_Code-selection"
																			classNamePrefix="select2-selection"
																			menuPortalTarget={
																				document.body
																			}
																			styles={{
																				menuPortal:
																					(
																						base
																					) => ({
																						...base,
																						zIndex: 9999,
																					}),
																			}}
																			options={this.props.WO_ReportData.map(
																				(
																					item,
																					index
																				) => ({
																					label: item.code,
																					value: item.id,
																				})
																			)}
																			value={{
																				label: this
																					.props
																					.Reportdata
																					?.POCodelabel,
																				value: this
																					.props
																					.params
																					?.POId,
																			}}
																			onChange={(
																				e
																			) => {
																				this.SelecteChangeValue(
																					{
																						key: "POCodelabel",
																						label: e.label,
																						key2: "POId",
																						value: e.value,
																					}
																				);
																			}}
																		/>
																	</FormGroup>
																</Col>
															)}
															{/* {this.props.reportType === "PendingList" && (
                                <Col md={3}>
                                  <FormGroup className="mb-0">
                                    <Label
                                      htmlFor="MR_Code-selection"
                                      className="col-form-label"
                                    >
                                      PO User :
                                    </Label>

                                    <Select
                                      id="MR_Code-selection"
                                      name="MR_Code-selection"
                                      classNamePrefix="select2-selection"
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      // options={this.props.WO_ReportData.map(
                                      //   (item, index) => ({
                                      //     label: item.code,
                                      //     value: item.id,
                                      //   })
                                      // )}
                                      // value={{
                                      //   label:
                                      //     this.props.Reportdata?.POCodelabel,
                                      //   value: this.props.params?.POId,
                                      // }}
                                      // onChange={(e) => {
                                      //   this.SelecteChangeValue({
                                      //     key: "POCodelabel",
                                      //     label: e.label,
                                      //     key2: "POId",
                                      //     value: e.value,
                                      //   });
                                      // }}
                                    />
                                  </FormGroup>
                                </Col>
                              )} */}
														</Row>

														<Row>
															<Col
																md={12}
																className="mt-1">
																<div className="float-right pt-1">
																	{this.props
																		.reportType ===
																		"document" && (
																		<Link
																			to={
																				"/srporeportdoc/" +
																				this
																					.props
																					.params
																					.POId
																			}>
																			<Button
																				block
																				type="button"
																				color="primary"
																				disabled={
																					this
																						.props
																						.params
																						.POId ==
																						null ||
																					this
																						.props
																						.params
																						.POId ===
																						""
																						? true
																						: false
																				}
																				className="waves-effect waves-light">
																				Generate
																				Report
																			</Button>
																		</Link>
																	)}
																	{this.props
																		.reportType ===
																		"PendingList" && (
																		<Link
																			to={
																				"/srporeportlist"
																			}>
																			<Button
																				block
																				type="button"
																				color="primary"
																				className="waves-effect waves-light">
																				Generate
																				Report
																			</Button>
																		</Link>
																	)}

																	{this.props
																		.reportType ===
																		"list" && (
																		<Link to="/srporeportlist">
																			<Button
																				block
																				type="button"
																				color="primary"
																				className="waves-effect waves-light">
																				Generate
																				Report
																			</Button>
																		</Link>
																	)}
																</div>
															</Col>
														</Row>
														{/* </div> */}
													</CardBody>
												</Card>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const {
		vendorslist,
		vendorsLoading,
		vendorParams,
		vendorslist2,
		sublocationslist2,
		sublocationParamas2,
		userLocation,
	} = state.Mini;
	const { srfqFilterList } = state.Quotation;
	const { params, reportType, Reportdata, WO_ReportData } = state.reports;
	return {
		vendorslist,
		vendorsLoading,
		vendorParams,
		vendorslist2,
		reportType,
		params,
		Reportdata,
		srfqFilterList,
		WO_ReportData,
		sublocationParamas2,
		userLocation,
		sublocationslist2,

		//-------
	};
};

export default connect(mapStatetoProps, {
	getMiniVendors,
	getUserLocations,
	getMini2Vendors,
	getWOreportslist,
	reportTypeCheck,
	SetParams,
	ReportsChangeValue,
	ReportsSelecteChangeValue,
	WOreportslistSuccessful,
	getSRFQFilterList,
	setSub2LocationParams,
	getMini2SubLocations,
	clearMini2SubLocations,
	ResetSubLocation,
})(SRPOReports);
